<template>
  <footer class="row text-center p-5" style="text-align:center; margin-top:-10px">
    <b-col  lg="4" sm="12"  class="p-5">
      <h3>Contáctanos</h3>
      <b-form v-if="show" >
        <b-form-group id="input-group-1" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Colócanos tu Email"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label-for="input-2">
          <b-form-input id="input-2" v-model="form.name" required placeholder="Nombre"></b-form-input>
        </b-form-group>

        <b-button
          type="submit"
          variant="secondary"
          style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:14px"
          class="shadow"
        >Enviar</b-button>
      </b-form>
    </b-col>
    <b-col  lg="4" sm="12" class="p-5">
      <h3>Instagram</h3>
      <!-- LightWidget WIDGET -->
      <iframe
        src="https://cdn.lightwidget.com/widgets/de5532ecabf15202acdb0fa0ab097b6e.html"
        scrolling="no"
        allowtransparency="true"
        class="lightwidget-widget"
        style="width:100%; height:350px; border:0;overflow:hidden;"
      ></iframe>
    </b-col>
    <b-col lg="4" sm="12" class="p-5" style="
    align-self: flex-end;
">
      <div class="mb-5" style="text-align:right">
        <a href="#">
          <font-awesome-icon
            :icon="['fab', 'instagram']"
            size="3x"
            :style="{ color: 'white', marginRight:'15px'}"
          />
        </a>
        <a href="#">
          <font-awesome-icon
            :icon="['fab', 'facebook']"
            size="3x"
            :style="{ color: 'white', marginRight:'15px'}"
          />
        </a>
        <a href="#">
          <font-awesome-icon
            :icon="['fab', 'linkedin']"
            size="3x"
            :style="{ color: 'white', marginRight:'15px'}"
          />
        </a>
      </div>
      <p>© 2018 Clubes de Tenis Asociados. Todos los derechos reservados.</p>
      <p>
        Producido por
        <a href="http://www.ticxel.com/" style="color:white"><b>Ticxel Agency</b>.</a>
      </p>
    </b-col>
  </footer>
</template>
<script src="https://cdn.lightwidget.com/widgets/lightwidget.js"></script>
<script>
export default {
  data() {
    return {
      form: {
        email: "",
        name: "",
        mensaje: ""
      },
      show: true
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.mensaje = null;

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>
<style scoped>
footer {
  background-color: #bfbfbf;
  background-image: url("~@/assets/images/pelota.png"),
    url("~@/assets/images/pelota.png");
  background-repeat: no-repeat;
  background-size: 300px, 300px;
  background-position: left bottom, right top;
}
p {
  font-size: 16px;
  color: white;

  text-align: right;
}
h3 {
  color: #fff;
  font-size: 22px;
  margin-bottom: 30px;
}
input,
textarea {
  background: #ddd !important;
  border-radius: 20px;
}
</style>
